export function schema_free() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
		},
	};
}
